var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('ul',{staticClass:"contact__lists"},_vm._l((_vm.pResult.results),function(contact){return _c('ContactListItem',{key:contact.id,attrs:{"contact":contact,"selectable":_vm.pSelectable},on:{"onActionClick":_vm.onActionClick,"onToggle":_vm.onToggle}})}),1)])
}
var staticRenderFns = []

export { render, staticRenderFns }